import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'
import { LevelDto } from '../../levels/response/level.dto'

export class ClassDto {
  @ApiProperty({
    description: 'ID de la classe',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({
    description: 'Nom de la classe',
    example: '6e A',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiProperty({
    description: "ID de l'établissement",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  establishmentId!: string

  @ApiProperty({
    description: 'ID externe du niveau',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  levelExternalId!: string

  @ApiProperty({
    description: 'Niveau',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: () => LevelDto,
  })
  @IsNotEmpty()
  @IsUUID('4')
  level!: LevelDto

  @ApiPropertyOptional({
    description: 'ID de la section',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  sectionId?: string

  @ApiProperty({
    description: 'ID du statut',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  statusId!: string

  @ApiProperty({
    description: "ID de l'année scolaire",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  schoolYearId!: string
}